export const AGENT_REPLY_POLL_INTERVAL_MS = 3_000;

export const AGENT_REPLY_POLL_TIMEOUT_MS = 5 * 60 * 1000;

export const AGENT_AUTO_REPLY_WATCH_INTERVAL_MS = 1_500;

export const AGENT_AUTO_REPLY_WATCH_MS = 9_000;
